import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Photo Hunter crashed:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div style={{
          padding: '24px',
          textAlign: 'center',
          color: 'var(--text)',
          background: 'var(--bg)',
          minHeight: '100dvh',
        }}>
          <p style={{ marginBottom: '16px' }}>Something went wrong.</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 18px',
              border: '1.5px solid var(--accent)',
              borderRadius: 'var(--radius)',
              color: 'var(--accent)',
              background: 'none',
              cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
